var _rect, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568:6",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F4842D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568:6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5445 45L9.8267 25.1046L8 17.0843L16.1412 7L25.2897 9.49641L45 29.3994L29.5445 45Z",
    fill: "url(#paint0_linear_568:6)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9925 16.7499C27.8582 10.7927 22.9908 6 16.9963 6C10.9196 6 6 10.927 6 16.9963C6 21.1992 8.35901 24.8571 11.8303 26.7085V23.3716V17.0709C11.8303 17.0261 11.8303 16.9888 11.8303 16.944C11.8303 14.3984 13.6593 12.2782 16.0706 11.8154V13.6444C14.6447 14.0624 13.6071 15.3838 13.6071 16.944C13.6071 16.9515 13.6071 16.9664 13.6071 16.9739V16.9888C13.6295 18.87 15.1673 20.3855 17.0485 20.3855C18.6088 20.3855 19.9226 19.3478 20.3482 17.9294H22.1771C21.7143 20.3407 19.5942 22.1622 17.0485 22.1622C15.7272 22.1622 14.5253 21.6695 13.6071 20.8632V27.4625C14.6746 27.8059 15.8168 28 17.0037 28C19.2881 28 21.4082 27.3057 23.17 26.1113V28H28L27.9925 16.7499ZM17.0411 18.9522C15.9287 18.9522 15.0329 18.0563 15.0329 16.944C15.0329 15.8317 15.9287 14.9359 17.0411 14.9359C18.1534 14.9359 19.0492 15.8317 19.0492 16.944C19.0492 18.0563 18.1534 18.9522 17.0411 18.9522ZM22.2667 16.9589H20.49C20.49 16.9515 20.49 16.9515 20.49 16.944C20.49 15.0404 18.9522 13.5025 17.0485 13.5025H17.0411V11.7258H17.0485C19.9301 11.7258 22.2667 14.0624 22.2667 16.944C22.2667 16.9515 22.2667 16.9515 22.2667 16.9589ZM25.3275 16.9589H23.5657C23.5657 16.9515 23.5657 16.9515 23.5657 16.944C23.5657 13.3458 20.6468 10.4269 17.0485 10.4269H17.0411V8.66508H17.0485C21.6247 8.66508 25.3275 12.3753 25.3275 16.944C25.3275 16.9515 25.3275 16.9515 25.3275 16.9589Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_568:6",
    x1: 12.7372,
    y1: 12.3888,
    x2: 41.2811,
    y2: 40.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1302,
    stopColor: "#E85D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    stopColor: "#F0772B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c8aba417.svg";
export { ForwardRef as ReactComponent };